module.exports = "//public.getcloudapp.com/packs/media/images/logo-visa-3bc611318472ba33af9c6085ade8f057.jpeg";